import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import classNames from 'classnames';

import { buttonVariants } from 'components/partials/button/button';

import Icons from 'assets/icons';
import getStartedImage from 'assets/images/get-started.png';

interface GetStartedGuideBannerProps {
  disabled?: boolean;
  isPopoverBanner?: boolean;
  isImgHidden?: boolean;
  customClass?: string;
  textFontSize?: string;
  headerFontSize?: string;
}

export const GetStartedGuideBanner = ({
  disabled = false,
  isPopoverBanner = true,
  isImgHidden = false,
  customClass = '',
  textFontSize = 'text-sm',
  headerFontSize = 'font-regular',
}: GetStartedGuideBannerProps): React.JSX.Element => (
  <div
    className={classNames(`flex p-4 bg-navy-50 rounded-lg ${customClass}`, {
      'flex-col max-w-[290px] justify-self-center xs:mt-[-120px] xs:row-start-3 xs:col-start-3 md:mt-auto md:row-span-2 md:row-start-1 md:col-start-4 md:self-unset':
        isPopoverBanner,
      'opacity-[35%]': disabled,
    })}
  >
    <img
      src={getStartedImage}
      alt="Get started guide illustration"
      className={classNames('flex h-full w-full mb-4', {
        '!hidden': isImgHidden,
        'mobile:hidden md:flex': isPopoverBanner,
      })}
    />
    <div>
      <p className={`text-navy-800 ${headerFontSize}`}>
        Check out our
        <span className="font-semibold block">Get Started Guide</span>
      </p>
      <p className={`text-gray-700 leading-{22px} py-2 ${textFontSize}`}>
        This comprehensive guide provides step-by-step instructions, practical
        tips, and valuable insights to help you kickstart your data analysis
        journey with confidence.
      </p>
      <RouterLink
        to="/learn/get-started-guide"
        className={classNames(
          buttonVariants({ variant: 'brand-filled', size: 'sm' }),
          'mt-2',
          {
            'pointer-events-none': disabled,
          }
        )}
      >
        Learn more
        <Icons.Arrow aria-hidden="true" />
      </RouterLink>
    </div>
  </div>
);

export default GetStartedGuideBanner;
